import React from 'react';
import StarRatings from 'react-star-ratings';
import Link from 'next/link';
import Reviews from '../category/Reviews';
import affirmDark from '@src/static/images/logos/affirm-dark.png';


const NotAvailable = (props) => {
	const { isLoading, urlSlug } = props;
	const geolocation = props.geolocation;
	return (
		<>
		<div className={`upsell-overlay sidebar active`}>
			<div className="inner-outside">
				{/* <button
					className="close-overlay btn"
					onClick={() => {
						this.setState({ showUpsellOverlay: false });
					}}>
					<i class="far fa-angle-double-down"></i> Close
				</button> */}

				<div className="inner">
					<h3>
						Mobile Car & Truck Battery Replacement Service in{' '}
						<span>{`${
							geolocation && geolocation.formatted_address
								? geolocation.formatted_address
								: 'Your City'
						}`}</span>
					</h3>
					<div className="body">
						<ul>
							<li>
								<i className="fas fa-check"></i> Book Online for <b>Immediate Delivery</b> or <b>Make Appointment</b>
							</li>
							<li>
								<i className="fas fa-check"></i> Installation Included in Price - No Hidden Charges!
							</li>
							<li>
								<i className="fas fa-check"></i> Our JumpStart Guarantee!
							</li>
							<li>
								<i className="fas fa-check"></i> Professional Technicans with Real Time Tracking!
							</li>
							<li>
								<i className="fas fa-check"></i> Buy now, pay over time with 
								<img
									src={affirmDark.src}
									alt="Car Battery Installation Video"
									className="lazyload"
								/>
							</li>
						</ul>

						{/* <div className="btn-container">
							<Link
								href={`/category/${urlSlug}`}>
								<button className="btn book">Schedule Online</button>
							</Link>
						</div> */}
						<div className="btn-container">
							<a href={`/category/${urlSlug}`} className="btn book">Schedule Online</a>
						</div>
					</div>
					<div className="footer mt-2">
						<Reviews type="minimal" />
					</div>
				</div>
			</div>
		</div>
	</>
	);
};

export default NotAvailable;
